<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card v-can="'view-product-stock-inventory'" titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters" class="user-list-filters mb-8" :collapse-action="true">
          <div class="vx-row">
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">Date/Time From</label>
              <flat-pickr
                          class="w-full"
                          :config="{ enableTime: true, dateFormat: 'd/m/Y H:i'}"
                          v-model="filters['from']"
                          placeholder="Choose Date"
              />
            </div>
            <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
              <label class="text-sm opacity-100 text-bold">Date/Time To</label>
              <flat-pickr
                          class="w-full"
                          :config="{ enableTime: true, dateFormat: 'd/m/Y H:i'}"
                          v-model="filters['to']"
                          placeholder="Choose Date"
              />
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full md:w-6/6">
              <div class="btn-group float-right">
                <vs-button color="danger" size="small" @click="onClickClearSearch">Clear</vs-button>
                <vs-button class="ml-2" color="success" size="small" @click="fetchRmBatch">Search</vs-button>
              </div>
            </div>
          </div>
        </vx-card>

        <vx-card v-can="'view-product-stock-inventory'">
          <div slot="no-body" class="mt-8">
            <vs-table id="raw-material-stock-table" max-items="10" :data="fg_batch_list"  sort  stripe class="table-dark-inverted table-auto vs-con-loading__container">

              <template slot="thead">
                <vs-th  class="text-sm" >ITS CODE</vs-th>
                <vs-th  class="text-sm" >CREATED AT</vs-th>
                <vs-th  class="text-sm" >CURRENT STOCK LEVEL (KG)</vs-th>
                <vs-th  class="text-sm" >AVAILBLE STOCK LEVEL (KG)</vs-th>
                <vs-th  class="text-sm" >CONFIRMED ORDER STOCK ALLOCATION (KG)</vs-th>
                <vs-th>TOTAL PRICE (GBP)</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr class="cursor-pointer" :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td :data="data[indextr].formulation_code">
                    {{ data[indextr].formulation_code }}
                  </vs-td>
                  <vs-td :data="data[indextr].created_at">
                    {{ data[indextr].created_at }}
                  </vs-td>
                  <vs-td :data="data[indextr].current_stock_level">
                    {{ data[indextr].current_stock_level }}
                  </vs-td>
                  <vs-td :data="data[indextr].available_stock">
                    {{ data[indextr].available_stock}}
                  </vs-td>
                  <vs-td :data="data[indextr].confirmed_order_stock_allocation">
                    {{ data[indextr].confirmed_order_stock_allocation }}
                  </vs-td>
                  <vs-td :data="data[indextr].sum_total_price">
                    {{ data[indextr].sum_total_price[0] || 'N/A' }}
                  </vs-td>


                  <template class="expand-user" slot="expand">
                    <div class="con-expand-users w-4/5">

                      <vs-table :hoverFlat="true" class="mt-8 mb-8" :data="tr.inventory">

                        <template slot="header">
                          <h5 class="mb-4">FG BATCH</h5>
                        </template>

                        <template slot="thead">
                          <vs-th width="15%">WO CODE</vs-th>
                          <vs-th width="10%">ORDER CODE</vs-th>
                          <vs-th width="5%">MAN DATE</vs-th>
                          <vs-th width="5%">EXP DATE</vs-th>
                          <vs-th width="10%">TOTAL QTY (KG)</vs-th>
                          <vs-th width="10%">COMPLETED QTY (KG)</vs-th>
                          <vs-th width="5%">PRICE (GBP)</vs-th>
                          <vs-th width="5%">TOTAL PRICE (GBP)</vs-th>
                        </template>

                        <template slot-scope="{data}">
                          <vs-tr :key="index_rm_batch" v-for="(tr_batch, index_rm_batch) in data">

                            <vs-td :data="tr_batch.work_order_code">
                              {{ tr_batch.work_order_code }}
                            </vs-td>

                            <vs-td :data="tr_batch.product_order_code">
                              {{ tr_batch.product_order_code }}
                            </vs-td>

                            <vs-td>
                              {{ tr_batch.manufacture_date }}
                            </vs-td>

                            <vs-td>
                              {{ tr_batch.expiration_date }}
                            </vs-td>
                            
                            <vs-td>
                              {{ tr_batch.total_quantity }}
                            </vs-td>

                            <vs-td>
                              {{ tr_batch.completed_quantity }}
                            </vs-td>

                            <vs-td>
                              {{ tr_batch.price }}
                            </vs-td>

                            <vs-td>
                              {{ tr_batch.total_price }}
                            </vs-td>

                          </vs-tr>
                        </template>

                      </vs-table>

                    </div>
                  </template>
                </vs-tr>
              </template>


            </vs-table>
            <vs-pagination
              v-on:changeMaxItems="changePage"
              :size-array="meta.total ? meta.total : 20"
              :max-items="perPage"
              description-body="Rows per page"
              description-connector="of"
              description-title="Records"
              description
              :description-items="descriptionItems"
              :total="(meta.last_page)? meta.last_page : 0"
              v-model="page"  class="p-5">
            </vs-pagination>

          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  import Filter from '@/mixins/filter';
  const InventoryRepository = RepositoryFactory.get('inventory')
  import {defaultPagination, perPageList} from "@/constants/config";
  import flatPickr from "vue-flatpickr-component";
  import 'flatpickr/dist/flatpickr.css'
  import ErrorMessages from '@/mixins/ErrorMessages'

  export default {
    name: 'FinishedProductBatchList',
    data () {
      return {
        id: '',
        fg_batch_list: [],
        filters: {
          from : '',
          to: ''
        },
        page : 1,
        total: 0,
        meta : {},
        sort : '',
        perPage: defaultPagination,
        descriptionItems: perPageList,
      }
    },
    components: {
      'v-select': vSelect,
      flatPickr,
    },
    mixins : [Filter, ErrorMessages],
    mounted() {
      this.id = this.$route.params.id
      this.fetchRmBatch()
    },
    methods: {
      async refreshData () {
        this.fetchRmBatch()
      },
      async fetchRmBatch() {
        await this.$vs.loading({
          container: '#raw-material-stock-table',
          scale: 0.45
        })
        try {
          const {data} = await InventoryRepository.getProductStockLog(this.id, this.page, this.filterQuery, this.perPage)
          this.fg_batch_list =  data.data
          this.meta = data.meta
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#raw-material-stock-table > .con-vs-loading')
      },
      filterQueryUpdate (){
        // this.fetchRmBatch()
      },
      handleChangePage(page) {
        this.page=page;
        this.fetchRmBatch()
      },

      handleSort(key, active) {
        if(key){
          active = (active==='desc')? "-":'';
          this.sort=active+key;
          this.fetchRmBatch()
        }
      },
      changePage(index) {
        this.perPage = this.descriptionItems[index]
      },
      onClickClearSearch() {
        this.filters = {
          from : '',
          to: ''
        }
      }
    },
    watch : {
      page(){
        this.fetchRmBatch()
      },
      perPage() {
        this.fetchRmBatch()
      }
    }
  }
</script>


<style scoped>

</style>
